import { useEffect, useState } from "react";

const useScroll = () => {

    const [IsScroll, setIsScroll] = useState<boolean>(Boolean)

    useEffect(() => {
        const handleScroll = (): void => {
            if(window.scrollY > 0){
                setIsScroll(true)
            } else {
                setIsScroll(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        
        return () => window.removeEventListener('scroll', handleScroll)
    },[])

    return {IsScroll}
};

export default useScroll